"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBookInteriorDesign;
const either_1 = require("../../types/either");
const isDesignAllowedForPrintableIdx_1 = __importDefault(require("./isDesignAllowedForPrintableIdx"));
/**
 *
 * @param template
 * @param interiorPrintableIdx Index of the interior printable
 * @param randomDesignSelectionSeed Used in conjunction with the printable index to randomly (and deterministically) select a design
 * @param coverage if this is a spread book, the coverage can be filtered by 'full' or 'partial'
 * @param withTags list of tags that should be included in the design selection, design must include any of the tags provided, not *all*.
 * @returns
 */
function getBookInteriorDesign(designs, interiorPrintableIdx, randomDesignSelectionSeed, filters) {
  let useUnfilteredAsBackup = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  let interiorDesigns = designs.filter(d => (0, isDesignAllowedForPrintableIdx_1.default)(d, interiorPrintableIdx));
  if (!interiorDesigns.length) {
    return (0, either_1.left)(new Error(`No interior designs found in template for interiorPrintableIdx: ${interiorPrintableIdx}`));
  }
  const interiorOrderDesigns = interiorDesigns.filter(d => d.order && d.default);
  // This conditional is used for books that in their template have designs with order
  if (interiorOrderDesigns.length !== 0) {
    const interiorOrderDesign = interiorOrderDesigns.find(d => {
      var _a;
      return (_a = d.order) === null || _a === void 0 ? void 0 : _a.includes(interiorPrintableIdx + 1);
    });
    if (interiorOrderDesign) {
      return (0, either_1.right)(interiorOrderDesign);
    }
  }
  if (filters && filters.length > 0) {
    let interiorDesignsFiltered = filters.reduce((designs, currentFilter) => designs.filter(currentFilter), interiorDesigns);
    // If all filters excluded all designs, try removing filters one by one from the end
    if (interiorDesignsFiltered.length === 0) {
      const remainingFilters = [...filters];
      while (remainingFilters.length > 1 && interiorDesignsFiltered.length === 0) {
        remainingFilters.pop();
        interiorDesignsFiltered = remainingFilters.reduce((designs, currentFilter) => designs.filter(currentFilter), interiorDesigns);
      }
    }
    if (interiorDesignsFiltered.length > 0) {
      interiorDesigns = interiorDesignsFiltered;
    } else if (!useUnfilteredAsBackup) {
      return (0, either_1.left)(new Error(`No interior designs found in template after filtering for interiorPrintableIdx: ${interiorPrintableIdx}`));
    }
  }
  const randomIdx = (randomDesignSelectionSeed + interiorPrintableIdx) % interiorDesigns.length;
  const randomDesign = interiorDesigns[randomIdx];
  return (0, either_1.right)(randomDesign);
}